module.exports = __webpack_public_path__ + "assets/img/binding-2-sm.65e1d9ab.jpg";